module.exports = "/images/abstract1.jpg?1dd1d1eddb0f502264da5054d9820fa6";